import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ProtectedRoute from "components/ProtectedRoute";

// Lazy-load all page components for code splitting
const ResearchCenter = lazy(() => import('./pages/research-center'));
const CRMContactDetails = lazy(() => import('./pages/crm-contact-details'));
const RegistrationLogin = lazy(() => import('./pages/registration-login'));
const NetworkFinder = lazy(() => import('./pages/network-finder'));
const ResumeBuilder = lazy(() => import('./pages/resume-builder'));
const CareerSeekerDashboard = lazy(() => import('./pages/career-seeker-dashboard'));
const Messages = lazy(() => import('./pages/messages'));
const TasksScheduling = lazy(() => import('./pages/tasks-scheduling'));
const AdminDashboard = lazy(() => import('./pages/admin-dashboard'));
const CareerCoachDashboard = lazy(() => import('./pages/career-coach-dashboard'));
const TrainingCenter = lazy(() => import('./pages/training-center'));
const AddContactPage = lazy(() => import('./pages/add-contact'));

// Minimal loading fallback — avoids layout shift
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen" style={{ backgroundColor: 'var(--color-background)' }}>
    <div className="flex flex-col items-center gap-3">
      <div className="w-8 h-8 rounded-full border-2 border-t-transparent animate-spin" style={{ borderColor: 'var(--color-secondary)', borderTopColor: 'transparent' }} />
      <p className="text-sm" style={{ color: 'var(--color-muted-foreground)' }}>Loading…</p>
    </div>
  </div>
);

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Suspense fallback={<PageLoader />}>
          <RouterRoutes>
            {/* Public routes */}
            <Route path="/registration-login" element={<RegistrationLogin />} />

            {/* Root redirect to login */}
            <Route path="/" element={<Navigate to="/registration-login" replace />} />

            {/* Protected routes */}
            <Route path="/career-seeker-dashboard" element={<ProtectedRoute><CareerSeekerDashboard /></ProtectedRoute>} />
            <Route path="/research-center" element={<ProtectedRoute><ResearchCenter /></ProtectedRoute>} />
            <Route path="/crm-contact-details" element={<ProtectedRoute><CRMContactDetails /></ProtectedRoute>} />
            <Route path="/network-finder" element={<ProtectedRoute><NetworkFinder /></ProtectedRoute>} />
            <Route path="/resume-builder" element={<ProtectedRoute><ResumeBuilder /></ProtectedRoute>} />
            <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
            <Route path="/tasks-scheduling" element={<ProtectedRoute><TasksScheduling /></ProtectedRoute>} />
            <Route path="/admin-dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/career-coach-dashboard" element={<ProtectedRoute><CareerCoachDashboard /></ProtectedRoute>} />
            <Route path="/training-center" element={<ProtectedRoute><TrainingCenter /></ProtectedRoute>} />
            <Route path="/add-contact" element={<ProtectedRoute><AddContactPage /></ProtectedRoute>} />

            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
